export enum FeatureFlag {
	enableStatusField = 'dt_enable_status_field',
	EnableResourceFreezing = 'enable_resource_freezing',
	EnableProjectAsSolution = 'work_management',
}
